import { render, staticRenderFns } from "./ReviewsSettingsCreateOrEditWizardButtons.vue?vue&type=template&id=0f0e8539&"
import script from "./ReviewsSettingsCreateOrEditWizardButtons.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettingsCreateOrEditWizardButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports